import React from 'react';
import { Grid, Button, Typography, Container} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { listingCss } from 'common/style/style';

const classes = listingCss();

const CommonListHeader = (props) => {
    const {title, description, buttonName, link} = props.value;
    const navi = useNavigate();

    const onButtonPress = () =>{
        navi(link);
    }

    return (
        <Container  maxWidth={false} sx={{paddingTop: "10px"}}>
            <Grid container item md={12} display="flex" justifyContent="space-between">
                <Grid container item md={6} display="flex" direction="column">
                    <Typography variant="h6">{title}</Typography>
                    <Typography variant="subtitle2">{description}</Typography>
                </Grid>  
                <Grid container item md={6} justifyContent="flex-end">
                {buttonName?<Button variant="contained" color="primary" size="small" onClick={()=>onButtonPress()}>{buttonName}</Button>:''}
                </Grid>
            </Grid>
        </Container>
    )
}

export default CommonListHeader;
